import axios from 'axios'

export { CancelToken, isCancel } from 'axios'

/**
 * This method must be moved to a common folder on the project or move to a common folder,
 * if we decided to use a monorepo
 * @param String url
 * @param String method
 * @param Object data
 * @param Object params
 * @param Object headers (optional)
 * @returns {Promise}
 */
export default function xhr({
  url,
  method,
  data,
  headers = {},
  cancelToken,
  params,
}) {
  return axios(url, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
      ...headers,
    },
    method,
    data,
    params,
    cancelToken,
  })
}
